import React, {memo, useEffect, useState} from "react"
import {HStack} from "../../../../ui/Stack"
import {Button} from "antd"
import {useLocation} from "react-router-dom"

interface IFilter {
    id?: number,
    name: string,
    code: string,
    style?: any
}

interface IButton {
    name: string,
    code: string,
    isActive: boolean
}

interface IFilterButtons {
    groupName?: string,
    filters?: IFilter[],
    onChange: (filters: any, isButtonChange?: boolean) => void,
    isSingleSelect?: boolean
}

const excludeButtonStages = ['done', 'cancelled']
export const FilterFastButtons = memo((props: IFilterButtons) => {
    const {
        groupName = 'stage',
        filters,
        onChange,
        isSingleSelect = false
    } = props
    const [buttons, setButtons] = useState<IButton[]>([])
    const location = useLocation()
    const [isUpd, setIsUpd] = useState(false)

    useEffect(() => {
        if (!filters) {
            return
        }
        let urlSearchParams = new URLSearchParams(location.search)

        const currentFilters = urlSearchParams.get(groupName)
        const currentFiltersArr = currentFilters?.split(',') || []

        const buttons = filters.filter((filter) => !excludeButtonStages.includes(filter.code))

        const result: IButton[] = buttons.map((filter) => ({
            name: filter.name,
            code: filter.code,
            isActive: currentFiltersArr.includes(filter.code)
        }))

        setButtons(result)
    }, [filters, groupName, location])

    useEffect(() => {
        if (!isUpd) return

        let urlSearchParams = new URLSearchParams(location.search)
        const currentUrlParams = (
          urlSearchParams.get(groupName)?.split(",") || []
        ).filter((param) => excludeButtonStages.includes(param))

        let resultButtons: string[] | string

        if (isSingleSelect) {
            const activeButton = buttons.find((button) => button.isActive && button.code !== "all")
            resultButtons = activeButton ? activeButton.code : ""
        } else {
            let tmp = new Set([
                ...currentUrlParams,
                ...buttons
                  .filter((button) => button.isActive && button.code !== "all")
                  .map((button) => button.code),
            ])
            resultButtons = Array.from(tmp)
        }

        if (
          (Array.isArray(resultButtons) && resultButtons.length === 0) ||
          resultButtons === "" ||
          (Array.isArray(resultButtons) && resultButtons.length === 1 && resultButtons[0] === "")
        ) {
            urlSearchParams.delete(groupName)
            resultButtons = Array.isArray(resultButtons) ? [] : ""
        }

        onChange({...Object.fromEntries(urlSearchParams), [groupName]: resultButtons}, true)
        setIsUpd(false)
    }, [buttons, groupName, location])

    const onClickButton = (code: string) => () => {
        setButtons((prevState) => {
            if (code === "all") {
                const currentAll = prevState.find((btn) => btn.code === "all")
                return prevState.map((prevButton) => ({
                    ...prevButton,
                    isActive: !currentAll!.isActive,
                }))
            }

            if (isSingleSelect) {
                return prevState.map((prevButton) => ({
                    ...prevButton,
                    isActive: prevButton.code === code ? !prevButton.isActive : false,
                }))
            }

            return prevState.map((prevButton) => {
                if (prevButton.code === code) {
                    return { ...prevButton, isActive: !prevButton.isActive }
                }
                return prevButton
            })
        })
        setIsUpd(true)
    }

    return (
      <HStack gap={"8"} justify={"start"} max style={{flexWrap: "wrap"}}>
          {
              buttons?.map((button) => {
                  const filter = filters?.find((s) => s.code === button.code)
                  const buttonStyle = filter?.style || {}

                  return <Button
                    key={button.name}
                    type={button.isActive ? 'primary' : 'default'}
                    onClick={onClickButton(button.code)}
                    style={{
                        color: button.isActive ? buttonStyle.color : 'inherit',
                        backgroundColor: button.isActive ? buttonStyle.backgroundColor : 'inherit',
                        //fontWeight: buttonStyle.fontWeight,
                        border: `2px solid ${buttonStyle.backgroundColor}`,
                        lineHeight: 'normal',
                        boxShadow: 'none'
                    }}
                  >
                      <span dangerouslySetInnerHTML={{ __html: button.name }} />
                  </Button>
              })
          }
      </HStack>
    )
})
